const getters = {
  aboutUs: state => {
    return state.aboutUs
  },
  benefits: state => {
    return state.benefits
  },
  slogan: state => {
    return state.slogan
  },
  inside: state => {
    return state.inside
  },
  team: state => {
    return state.team
  },
  kpi: state => {
    return state.kpi
  },
  banner: state => {
    return state.banner
  },
  allBenefits: state => {
    return state.allBenefits
  },
  isPublished: state => {
    return state.isPublished
  },
  socials: state => {
	return state.socials
  },
  publicProfile: state => {
	return state.publicProfile
  }
}

export default getters
